import { AxiosResponse } from "axios";
import { axiosObj } from "./axios";
 
 
//Creating new tribe
export const createTribe = async (formData: FormData, accessToken: string): Promise<any> => {
  const newTribeResponse = axiosObj.post(`/tribes/createTribe`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await newTribeResponse).data
};
 
 
//Updating the tribe
export const updateTribe = async (formData: FormData, accessToken: string): Promise<any> => {
  const updatedTribeResponse = axiosObj.put(`/tribes/updateTribe`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return (await updatedTribeResponse).data
};
 
 
//Getting the tribe by Id
export const getTribeById = async (id: string, accessToken: string): Promise<any> => {
  const TribeByIdData = axiosObj.get(`/tribes/${id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
 
  return (await TribeByIdData).data
};
 
 
//Getting all tribe with offset and count
export const getAllTribesByOffset = async (offset: string, count: string, accessToken: string): Promise<any> => {
  const TribeByIdData = axiosObj.get(`/tribes?offset=${offset}&count=${count}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });
  return (await TribeByIdData).data
};
 
//Getting all tribe
export const getAllTribes = async (accessToken: string): Promise<any> => {
  const TribeByIdData = axiosObj.get(`tribes/getAllTribe`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });
  return (await TribeByIdData).data
};
 
//Deleting the Tribe 
export const deleteTribe = async (id: string, accessToken: string): Promise<AxiosResponse> => {
  const deleteTribeData = axiosObj.delete(`/tribes/${id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
 
  return (await deleteTribeData).data
};
 
 
//Search Tribe by tribe name with offset limit and Count 
export const searchTribe = async (searchText: string, status: string, startDate: string | null, endDate: string | null, offset: string,
  count: string, accessToken: string) => {
  const queryParams = new URLSearchParams();
 
  if (searchText) queryParams.append("name", searchText);
  if (status) queryParams.append("published", status);
  if (startDate) queryParams.append("start_date", startDate);
  if (endDate) queryParams.append("end_date", endDate);
  queryParams.append("offset", offset);
  queryParams.append("count", count);
 
  const url = `tribes/searchTribeByFilter?${queryParams.toString()}`;
 
  try {
    const response = await axiosObj.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
 
    return response.data;
  } catch (error) {
    console.error("Error in searchTribe API:", error);
    throw error;
  }
};
 
 
//Deleting the specific Subject
export const deleteTribeSubject = async (subjectId: string, accessToken: string) => {
  const deletedSubject = axiosObj.delete(`/subjects/${subjectId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
 
  return (await deletedSubject).data
}
 
export const getGrade = async (): Promise<any> => {
  const gradeData = axiosObj.get('/grade')
  return (await gradeData).data
 
}
 
export const checkTribeNameExist = async(tribeId: string, tribeName: string) => {
  
 
  // Build query parameters dynamically
  const queryParams = new URLSearchParams();
 
  if (tribeId) queryParams.append("id", tribeId);
  if (tribeName) queryParams.append("name", tribeName);
 
  const CheckTribeNameExistData = axiosObj.get(`/tribes/checkTribeName?${queryParams.toString()}`, {
    headers: {
        "Content-Type": "application/json",
    }
});
return (await CheckTribeNameExistData).data
}
 
export const checkSubjectNameExist = async(tribeId: string, subjectName: string) => {
  const CheckSubjectNameExistData = axiosObj.get(`/subjects/checkSubjectName/${subjectName}/${tribeId}`, {
    headers: {
        "Content-Type": "application/json",
    }
});
return (await CheckSubjectNameExistData).data
}